import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import {Amplify} from "aws-amplify";
import { environment } from '../environments/environment';
import { authInterceptor } from './interceptors/auth.interceptor';
import { TimeagoModule } from 'ngx-timeago';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNgxMask } from 'ngx-mask'; 

Amplify.configure({

  Auth: {
    Cognito: {
      userPoolClientId: environment.userPoolClientId,
      userPoolId: environment.userPoolId,
      identityPoolId: environment.identityPoolId,
      signUpVerificationMethod: "code",
      loginWith: {
        username: true
      }
    },
  },
});

//cognitoUserPoolsTokenProvider.setKeyValueStorage(new CognitoTokenStorage());


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    importProvidersFrom(
      TimeagoModule.forRoot()
    ),
    provideNgxMask()
  ]
};
